var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9C8 9.6 7.5 10 7 10H5C4.4 10 4 9.5 4 9C4 8.5 4.5 8 5 8H7C7.6 8 8 8.4 8 9ZM7 4H5C4.4 4 4 4.5 4 5C4 5.6 4.5 6 5 6H7C7.6 6 8 5.5 8 5C8 4.5 7.6 4 7 4ZM18 18.8C18 19.5 17.5 20 16.9 20C11.7 20 6.4 20 1.2 20C0.4 20 0 19.5 0 18.8C0 15.9 0 13 0 10C0 7.1 0 4.1 0 1.2C0 0.5 0.4 0 1.1 0C4.3 0 7.6 0 10.8 0C11.6 0 12 0.4 12 1.1C12 3.3 12 5.4 12 7.6C12 8 12 8 12.3 8C13.8 8 15.3 8 16.8 8C17.6 8 18 8.4 18 9.1C18 12.4 18 15.6 18 18.8ZM10 2.4C10 2.2 9.9 2.1 9.7 2.1C7.3 2.1 4.8 2.1 2.4 2.1C2.1 2.1 2 2.1 2 2.3C2 7.4 2 12.5 2 17.6C2 17.8 2 17.9 2.3 17.9C3.1 17.9 3.9 17.9 4.7 17.9C4.9 17.9 5 17.8 5 17.6C5 17.1 5 16.5 5 16V15.9V15.8C5 15.8 5 15.8 5 15.7C5.1 15.2 5.5 14.8 6 14.8C6.6 14.8 7 15.3 7 15.8V16C7 16.5 7 17.1 7 17.6C7 17.8 7.1 17.9 7.3 17.9C8.1 17.9 8.8 17.9 9.6 17.9C9.9 17.9 10 17.9 10 17.6C10 15.1 10 12.5 10 10C10 7.5 10 4.9 10 2.4ZM15.9 17.6C15.9 16.4 15.9 15.2 15.9 13.9C15.9 12.7 15.9 11.4 15.9 10.2C15.9 10 15.8 9.9 15.6 9.9C14.5 9.9 13.3 9.9 12.2 9.9C12 9.9 11.9 10 11.9 10.2C11.9 12.7 11.9 15.1 11.9 17.6C11.9 17.8 12 17.9 12.2 17.9C13.3 17.9 14.4 17.9 15.5 17.9C15.9 17.9 15.9 17.9 15.9 17.6Z",
    fill: "#63C0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployers);
export default __webpack_public_path__ + "static/media/employers.1c43f5c958ed8d8dac567ad04c5ba6d9.svg";
export { ForwardRef as ReactComponent };